const MX_PHONE_CODE = '52';

export const cleanMXPhone = phone => `${MX_PHONE_CODE}${phone.split(' ').join('')}`;
